import { render, staticRenderFns } from "./StpSearch.vue?vue&type=template&id=9aeb1d46&"
import script from "./StpSearch.vue?vue&type=script&lang=ts&"
export * from "./StpSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports